import React, { useEffect, useState } from 'react';

interface ImageWithFallbackProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  fallbackText?: string;
}

export function ImageWithFallback({
  src,
  alt,
  className = '',
  fallbackText = 'Error loading image',
  onError,
  onLoad,
  ...rest
}: ImageWithFallbackProps) {
  const [didError, setDidError] = useState(false);

  useEffect(() => {
    setDidError(false);
  }, [src]);

  if (didError) {
    return (
      <div className={`image-fallback ${className}`}>
        <div className="image-fallback__text">{fallbackText}</div>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      {...rest}
      onLoad={(event) => {
        onLoad?.(event);
      }}
      onError={(event) => {
        setDidError(true);
        onError?.(event);
      }}
    />
  );
}
